<template>
  <div v-html="htmlIntroduction"></div>
  <form @submit.prevent="onSubmit">
    <div class="o-form">
      <div class="o-input">
        <label class="o-input__label">Maak een keuze</label>
        <div class="o-input__controls">
          <KlasSelector v-model="selectedKlasId" :nodes="klasTree.roots" :selectedIds="selectedIds" />
        </div>
      </div>
    </div>
    <div v-if="showIsNewCustomer" class="o-input" :style="{ opacity: selectedKlas?.hasNewCustomersOnly ? '1' : '.4' }">
      <label for="isNewCustomerInput" class="o-input__label">Nieuwe leerling</label>
      <div v-if="selectedKlas?.hasNewCustomersOnly" class="o-input__controls">
        <div class="c-checkbox">
          <label>
            <input type="checkbox" v-model="isNewCustomer" id="isNewCustomerInput" :disabled="!selectedKlas?.hasNewCustomersOnly" />
            <!-- Nieuwe leerling -->
          </label>
        </div>
      </div>
      <div v-else style="padding: 0.8rem 0">(n.v.t.)</div>
    </div>
    <footer class="c-container__footer">
      <div class="o-toolbar">
        <div class="o-toolbar__right">
          <button type="submit" class="c-button c-button--primary">Volgende</button>
        </div>
      </div>
      <div v-if="lastPaidOrder != null" class="has-info" style="float: right">
        Vorige bestelling werd geplaatst op {{ moment(lastPaidOrder.created).format("DD/MM/yyyy") }}
      </div>
    </footer>
  </form>
</template>

<script>
import moment from "moment";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ref, computed, watchEffect, onMounted } from "vue";
import { getLastPredefinedPaidOrder } from "../infrastructure/order-functions";
import { addTargetBlankToAnchors } from "../infrastructure/utilities";
import { TreeList } from "@/regira_modules/treelist";
import KlasSelector from "../components/KlasSelector";

export default {
  props: {
    klasId: { type: String, required: false },
  },
  components: { KlasSelector },
  setup(props) {
    const store = useStore();
    const router = useRouter();

    const klasTree = new TreeList();
    klasTree.init(store.state.data.klassen, (v, items) => items.filter((p) => p.id == v.parentId));

    const selectedKlasId = ref();
    const selectedIds = ref([]);

    const showIsNewCustomer = computed(() => klasTree.some((n) => n.value.hasNewCustomersOnly));
    const selectedKlas = computed(() => store.getters["data/findKlas"](selectedKlasId.value));
    const isNewCustomer = ref(store.state.orders.order.isNewCustomer);
    //  computed({
    //   get: () => store.state.orders.order.isNewCustomer,
    //   set: (value) => (store.state.orders.order.isNewCustomer = value),
    // });

    const onSubmit = async () => {
      if (!selectedKlasId.value) {
        return;
      }
      const klasNode = klasTree.find((n) => n.value.id == selectedKlasId.value);
      if (klasNode?.children?.length) {
        return;
      }

      await store.dispatch("orders/submitKlas", { klasId: selectedKlasId.value, isNewCustomer: isNewCustomer.value });
      router.push({ name: "cataloog", params: { klasId: selectedKlasId.value } });
    };

    watchEffect(() => {
      if (props.klasId) {
        const klasNode = klasTree.find((n) => n.value.id == props.klasId);
        if (klasNode) {
          const ancestors = klasNode.getAncestors();
          selectedIds.value = [props.klasId, ...ancestors.map((n) => n.value.id)];
        }
      }
    });
    watchEffect(() => {
      selectedKlasId.value = store.state.orders.order?.klasId;
    });

    const lastPaidOrder = ref();
    onMounted(async () => {
      console.debug("mounted", { order: store.state.orders.order });
      const orderGuid = store.state.orders.order.guid;
      if (orderGuid) {
        lastPaidOrder.value = await getLastPredefinedPaidOrder(orderGuid, store.state.appId);
        console.debug("lastPaidOrder", { lastPaidOrder });
      }
    });

    return {
      htmlIntroduction: addTargetBlankToAnchors(store.state.webshop.introduction),
      lastPaidOrder,
      selectedKlas,
      showIsNewCustomer,
      isNewCustomer,
      selectedKlasId,
      selectedIds,
      klasTree,
      onSubmit,
      moment,
    };
  },
};
</script>
